export default "__VITE_PUBLIC_ASSET__d3239dfb__"